document.addEventListener("DOMContentLoaded", function () {
  // Wire up all video containers that declare a controls toggle
  document
    .querySelectorAll(".video-container[data-video-controls]")
    .forEach(function (container) {
      if (container.getAttribute("data-controls-init") === "true") return;
      container.setAttribute("data-controls-init", "true");

      var shouldShowControls = container.getAttribute("data-video-controls");
      shouldShowControls = shouldShowControls === "true";

      var applyControls = function (vid) {
        if (!vid) return;

        var preventControls = function () {
          vid.removeAttribute("controls");
          vid.controls = false;
        };

        if (shouldShowControls) {
          vid.setAttribute("controls", "controls");
          if (vid._controlsObserver) {
            try {
              vid._controlsObserver.disconnect();
            } catch (e) {}
            vid._controlsObserver = null;
          }
          if (vid._preventControlsHandler) {
            vid.removeEventListener("mouseenter", vid._preventControlsHandler);
            vid.removeEventListener("mousemove", vid._preventControlsHandler);
            vid.removeEventListener("click", vid._preventControlsHandler);
            vid._preventControlsHandler = null;
          }
        } else {
          preventControls();
          if (!vid._preventControlsHandler) {
            vid._preventControlsHandler = function () {
              preventControls();
            };
            vid.addEventListener("mouseenter", vid._preventControlsHandler);
            vid.addEventListener("mousemove", vid._preventControlsHandler);
            vid.addEventListener("click", vid._preventControlsHandler);
          }
          if (!vid._controlsObserver) {
            vid._controlsObserver = new MutationObserver(function (mutations) {
              mutations.forEach(function (m) {
                if (m.type === "attributes" && m.attributeName === "controls") {
                  preventControls();
                }
              });
            });
            vid._controlsObserver.observe(vid, {
              attributes: true,
              attributeFilter: ["controls"],
            });
          }
        }

        if (container.getAttribute("data-video-autoplay") === "true")
          vid.autoplay = true;
        if (container.getAttribute("data-video-loop") === "true")
          vid.loop = true;
        if (container.getAttribute("data-video-muted") === "true")
          vid.muted = true;
      };

      var videoHost =
        container.querySelector(".video-container__video") || container;
      // Apply immediately if a <video> already exists
      var existing = videoHost.querySelector("video");
      if (existing) applyControls(existing);

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              var vid =
                node.tagName === "VIDEO"
                  ? node
                  : node.querySelector
                    ? node.querySelector("video")
                    : null;
              if (vid) applyControls(vid);
            }
          });
        });
      });

      if (videoHost) {
        observer.observe(videoHost, { childList: true, subtree: true });
      }
    });
});
